import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/ims/stock-return/{id}/submit`。body 含 updatedAt。 */
export async function submitStockReturn(id, payload = {}) {
  const { data: raw } = await request.post(
    `/ims/stock-return/${id}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
